import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function AmenitiesIntro() {
  return (
    <section
      id="overview"
      aria-labelledby="amenities-intro-heading"
      className="bg-background pb-16 pt-26 md:pb-20 md:pt-28"
    >
      <div className="shell">
        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>Make Yourself at Home</Eyebrow>
            </Reveal>
            <h2 id="amenities-intro-heading" className="display-lg mt-6 max-w-[14ch]">
              <MaskReveal>Comfort Comes</MaskReveal>
              <MaskReveal delay={0.08}>Standard</MaskReveal>
            </h2>
            <Reveal delay={0.12}>
              <div className="mt-8 space-y-5 text-base leading-relaxed text-muted-foreground md:text-[1.05rem]">
                <p>
                  Auburn RV Resort offers the amenities travelers need to slow down, recharge and
                  get ready for the next adventure. Whether you&apos;re staying for a night, a week
                  or a little longer, you&apos;ll have convenient access to essential facilities
                  throughout your stay.
                </p>
                <p>
                  The resort is pet friendly and located just a short drive from shopping, everyday
                  services and businesses in Auburn, making it easy to take care of the practical
                  things while enjoying the Sierra Foothills.
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.18}>
              <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
                <ResortLink variant="solid" href="/accommodations/" className="w-full sm:w-auto">
                  View Our RV Sites
                </ResortLink>
                <ResortLink variant="outline" href="/reservations/" className="w-full sm:w-auto">
                  Check Availability
                </ResortLink>
              </div>
            </Reveal>
          </div>

          <Reveal className="relative lg:col-span-6" y={36}>
            <img
              src={images.clubhouse}
              alt="Bath and shower facilities at Auburn RV Resort"
              width={1200}
              height={1400}
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
